import type { ModuleNav } from '@saas/ui';

/**
 * relationship のメニュー（03 §17.6・§17.7）。
 * 顧客の関係プロファイル（/relationship/customers/:id）は crm の顧客詳細から遷移するのでメニューには出さない。
 * ★ 「誰が何社と繋がっているか」のランキングは作らない（§17.7）。出すのは自分の関係一覧と、答えるべき 1 問だけ。
 * badge: 'relationship.unmatched' はシェルが GET /relationship/unmatched/count で埋める（未対応なら数字が出ないだけ）。
 */
export const relationshipNav: ModuleNav = {
  module: 'relationship',
  items: [
    { label: '未確定の名寄せ', to: '/relationship/unmatched', icon: 'help', permission: ['relationship.profile.read'], badge: 'relationship.unmatched', description: '「先方はどなたが出席されましたか？」に 1 タップで答える' },
    { label: '自分の接点', to: '/relationship/users/me', icon: 'account_tree', permission: ['relationship.profile.read'], description: '自分が繋がっている取引先と、引き継ぎが要る相手' },
  ],
  admin: [],
};
